<template>
    <div>

        <table class="mobile-table no-stripe tbody-stripe">
            <thead>
            <tr>
                <th>Country</th>
                <th>Identifier</th>
                <th colspan="2">Name</th>
            </tr>
            </thead>
            <tbody v-if="$apollo.queries.readCertifiedBodies.loading">
            <tr>
                <th colspan="4">
                    <i class="svg-icon bg-contain w-4 h-4 -refresh animate-spin" aria-hidden="true"
                       :style="'background-image: url('+refreshImageLocation+')'"></i>
                    Loading....
                </th>
            </tr>
            </tbody>
            <tbody v-for="(body, index) in readCertifiedBodies" :key="body.id"
                   class="border-b border-b-light-grey cursor-pointer"
                   :class="[(isEven(index)) ? 'bg-white' : 'bg-light']">
            <tr :class="[(isEven(index)) ? 'bg-white' : 'bg-light']" v-on:click.prevent="toggleFeature(index)">
                <td class="align-middle font-medium md:w-2/12 ">{{ body.node.organisation.country.title }} </td>
                <td class="align-middle">{{ body.node.organisation.acronym }}</td>
                <td class="align-middle">{{ body.node.organisation.title }}</td>
                <td class="align-middle text-right"><span :class="[(feature === index) ? 'rotate-180' : 'rotate-0']"
                      class="svg-icon bg-contain w-4 h-4 -chevron-down transition-[transform]"
                      :style="'background-image: url('+arrowLocation+')'"></span></td>
            </tr>
            <tr v-if="(feature === index)" :class="[(isEven(index)) ? 'bg-white' : 'bg-light']">
                <td colspan="4" class="p-0 " :class="[(isEven(index)) ? 'bg-white' : 'bg-light']">

                    <table class="mobile-table">
                        <tr class="" :class="[(isEven(index)) ? 'bg-white' : 'bg-light']">
                            <td class="md:w-2/12 font-medium">Logo</td>
                            <td><img :src="body.node.organisation.logoImage" width="150" class="w-[150px]"></td>
                        </tr>
                        <tr class="" :class="[(isEven(index)) ? 'bg-white' : 'bg-light']">
                            <td class="md:w-2/12 font-medium">Contact</td>
                            <td>
                                <div>
                                    {{ body.node.primaryContact.firstName }} {{ body.node.primaryContact.lastName }}
                                </div>
                                <div v-if="body.node.usePersonalDetails">
                                    <p class="!mt-2 !mb-0" v-if="body.node.primaryContact.phone">
                                        <span class="svg-icon mt-2 mb-0 inline-block bg-contain w-3 h-3 -phone"
                                              :style="'background-image: url('+phoneImageLocation+')'"></span> {{ body.node.primaryContact.phone }}
                                    </p>
                                    <p class="!mt-2 !mb-0" v-if="body.node.primaryContact.fax">
                                          <span class="svg-icon mt-2 mb-0 inline-block bg-contain w-3 h-3 -fax"
                                                :style="'background-image: url('+faxImageLocation+')'"></span>
                                        {{ body.node.primaryContact.fax }}
                                    </p>
                                    <p class="!mt-2 !mb-0" v-if="body.node.primaryContact.email">
                                        <span class="svg-icon mt-2 mb-0 inline-block bg-contain w-3 h-3 -phone"
                                              :style="'background-image: url('+emailImageLocation+')'"></span> {{ body.node.primaryContact.email }}
                                    </p>
                                </div>
                                <div v-else>
                                    <p v-if="body.node.organisationAddress.location">
                                        {{ body.node.organisationAddress.location }}</p>
                                    <p v-if="body.node.organisationAddress.address"
                                       v-html="htmlize(body.node.organisationAddress.address)"></p>
                                    <p v-if="body.node.organisationAddress.postalAddress">
                                        <strong>Postal Address:</strong><br>
                                        <span v-html="body.node.organisationAddress.postalAddress"></span>
                                    </p>
                                    <p class="!mt-2 !mb-0" v-if="body.node.organisationAddress.phone">
                                          <span class="svg-icon mt-2 mb-0 inline-block bg-contain w-3 h-3 -phone"
                                            :style="'background-image: url('+phoneImageLocation+')'"></span> {{ body.node.organisationAddress.phone }}
                                    </p>
                                    <p class="!mt-2 !mb-0" v-if="body.node.organisationAddress.fax">
                                          <span class="svg-icon mt-2 mb-0 inline-block bg-contain w-3 h-3 -fax"
                                            :style="'background-image: url('+faxImageLocation+')'"></span> {{ body.node.organisationAddress.fax }}
                                    </p>
                                    <p class="!mt-2 !mb-0" v-if="body.node.organisationAddress.email">
                                          <span class="svg-icon mt-2 mb-0 inline-block bg-contain w-3 h-3 -phone"
                                            :style="'background-image: url('+emailImageLocation+')'"></span> {{ body.node.organisationAddress.email }}
                                    </p>

                                </div>
                            </td>
                        </tr>
                        <tr class="" :class="[(isEven(index)) ? 'bg-white' : 'bg-light']">
                            <td class="md:w-2/12 font-medium">Scope</td>
                            <td class="">
                                <div class="not-prose">
                                    <p class="mb-[1.25rem] mt-0" v-for="standard in body.node.certificationStandards.edges">
                                        {{ standard.node.prefix }}{{ standard.node.number }}: {{ standard.node.title }}
                                    </p>

                                </div>
                            </td>
                        </tr>
                        <tr class="" v-if="body.node.notes" :class="[(isEven(index)) ? 'bg-white' : 'bg-light']">
                            <td class="md:w-2/12 font-medium">Notes</td>
                            <td class="">
                                <div class="not-prose [&>:first-child]:mt-0" v-html="body.node.notes">
                                </div>
                            </td>
                        </tr>
                    </table>


                </td>
            </tr>
            </tbody>


        </table>

    </div>
</template>

<script>

import gql from "graphql-tag";

export default {
    name: "CertificationBodyPage",
    props: {
        arrowLocation: {
            type: String,
            default: ""
        },
        phoneImageLocation: {
            type: String,
            default: ""
        },
        emailImageLocation: {
            type: String,
            default: ""
        },
        faxImageLocation: {
            type: String,
            default: ""
        },
        refreshImageLocation: {
            type: String,
            default: ""
        },
        schemeId: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            certificationBodies: [],
            currentBody: {},
            feature: -1
        };
    },
    methods: {
        htmlize: function (text) {
            return text.replace(/\n/g, "<br>");
        },
        isEven: function (index) {
            return index % 2 === 0;
        },
        toggleFeature: function (index) {
            this.feature = (this.feature === index) ? -1 : index;
        }
    },
    apollo: {
        readCertifiedBodies: {
            query: gql`
                query readCertifiedBodies($schemeid: ID) {
                  readCertifiedBodies (sort: {organisation: {country: {title: ASC}}},  filter: {certificationSchemeID: {eq: $schemeid}} ) {
                    edges {
                      node {
                        id
                        notes
                        usePersonalDetails
                        organisation {
                          id
                          acronym
                          title
                          logoImage
                          country {
                            id
                            title
                          }
                        }
                        organisationAddress {
                          id
                          location
                          address
                          postalAddress
                          phone
                          secondaryPhone
                          fax
                          email
                          country {
                            title
                          }
                        }
                        certificationScheme {
                          id
                          title
                        }
                        primaryContact {
                          id
                          firstName
                          lastName
                          phone
                          fax
                          email
                        }
                        associatedBodies {
                          edges {
                            node {
                              id
                              notes
                            }
                          }
                        }
                        certificationStandards(sort: {sortOrder: ASC}) {
                          edges {
                            node {
                              id
                              title
                              prefix
                              number
                              part
                              subPart
                            }
                          }
                        }
                      }
                    }
                  }
                }`,
            variables() {
                return {
                    schemeid: this.schemeId
                }
            },
            update: function (data) {
                console.log(data);
                return data.readCertifiedBodies.edges;
            },
            fetchPolicy: 'cache-and-network'
        }
    }
}

</script>

<style scoped>

</style>
